import { Link } from 'react-router-dom'
import { BlogListSkeleton } from '../components/Skeleton'
import { BLOG_LIST_META } from '../constants/home'
import { formatDate } from '../helpers/format'
import { useBlogPosts } from '../hooks/useBlogPosts'
import '../styles/blog-page.scss'

export function BlogListPage() {
  const { posts, loading, error } = useBlogPosts()

  return (
    <div className="blog-page">
      <section className="blog-page__hero">
        <div className="container">
          <h1>{BLOG_LIST_META.title}</h1>
          <p>{BLOG_LIST_META.subtitle}</p>
        </div>
      </section>

      <section className="section blog-page__list">
        <div className="container">
          {loading ? <BlogListSkeleton /> : null}
          {error ? <p className="catalog-status catalog-status--error">{error}</p> : null}
          {!loading && !error && posts.length === 0 ? (
            <p className="catalog-status">No published articles yet.</p>
          ) : null}

          {!loading && posts.length > 0 ? (
            <div className="blog-list">
              {posts.map((post) => (
                <Link key={post.id} to={post.to} className="blog-card blog-card--list">
                  <div className="blog-card__media">
                    {post.coverImageUrl ? (
                      <img src={post.coverImageUrl} alt="" className="blog-card__image" />
                    ) : (
                      <div className="blog-card__placeholder" aria-hidden />
                    )}
                  </div>
                  <div className="blog-card__body">
                    {post.publishedAt ? (
                      <time className="blog-card__date" dateTime={post.publishedAt}>
                        {formatDate(post.publishedAt)}
                      </time>
                    ) : null}
                    <h2>{post.title}</h2>
                    {post.excerpt ? <p>{post.excerpt}</p> : null}
                    <span className="blog-card__read-more">Read article →</span>
                  </div>
                </Link>
              ))}
            </div>
          ) : null}
        </div>
      </section>
    </div>
  )
}
